export const ACCEPT_FILE_TEXT_TYPES = [
  // Text
  'text/csv',
  'text/html',
  'text/calendar',
  'text/javascript',
  'text/plain',
  'text/xml',
  // 'text/rtf', // Rich Text Format

  'application/json', // JSON
  'application/ld+json', // JSON-LD
  'application/pdf', // Adobe Portable Document Format (PDF)

  // Microsoft
  'application/msword', // Word document
  'application/vnd.openxmlformats-officedocument.wordprocessingml.document', // Word document (docx)
  // 'application/vnd.ms-powerpoint', // Powerpoint
  // 'application/vnd.openxmlformats-officedocument.presentationml.presentation', // Powerpoint (pptx)
  'application/vnd.ms-excel', // Excel
  'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet', // Excel (xlsx)
]

export const ACCEPT_FILE_IMAGE_TYPES = ['image/jpeg', 'image/png', 'image/gif']
